import { rpcDefinition } from "@redotech/redo-merchant-concierge-rpc/definition";
import type { ClientOptions } from "@redotech/rpc/client";
import { createRpcContractClient } from "@redotech/rpc/client";
import type { RedoConciergeRpcContract } from "./rpc-contract.generated";

export function createRedoConciergeRpcClient(
  options: ClientOptions<RedoConciergeRpcContract>,
): RedoConciergeRpcContract {
  return createRpcContractClient<RedoConciergeRpcContract>(
    rpcDefinition,
    options,
  );
}

export type RedoConciergeRpcClient = RedoConciergeRpcContract;
